export default "__VITE_PUBLIC_ASSET__19499d66__"